import React from 'react';
import { cn } from './cn.js';

export function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        'rounded-[30px] border border-ptcm-border/80 bg-white/90 text-ptcm-ink shadow-ptcm-card backdrop-blur-sm transition-shadow hover:shadow-ptcm-soft',
        'dark:border-gray-800 dark:bg-gray-900 dark:text-gray-100 dark:shadow-none',
        className
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }) {
  return <div className={cn('p-6 pb-0 sm:p-7 sm:pb-0', className)} {...props} />;
}

export function CardTitle({ className, children, ...props }) {
  return <h3 className={cn('font-display text-lg font-semibold leading-tight tracking-tight', className)} {...props}>{children}</h3>;
}

export function CardDescription({ className, ...props }) {
  return <p className={cn('text-sm leading-6 text-ptcm-muted dark:text-gray-300', className)} {...props} />;
}

export function CardContent({ className, ...props }) {
  return <div className={cn('p-6 sm:p-7', className)} {...props} />;
}

export function CardFooter({ className, ...props }) {
  return <div className={cn('p-6 pt-0 sm:p-7 sm:pt-0 flex items-center', className)} {...props} />;
}

